<template>
  <div
    v-if="!isCartOpen"
    class="info-card"
    :class="{ 'info-card--open': isCartOpen }"
  >
    <div v-if="!isMobile" class="card-content">
      <div class="icon-bg">
        <v-icon
          class="cart-icon"
          :color="'white'"
          :icon="'mdi-cart-outline'"
        ></v-icon>
      </div>
      <div class="fields-wrapper">
        <div class="fields">
          <div class="field">
            <label>יחידות</label>
            <div class="value">{{ cartUnitsNumber }}</div>
          </div>
          <div class="field">
            <label> במארז</label>
            <div class="value">{{ getTotalCartPackges }}</div>
          </div>
        </div>
        <div class="button-wrapper">
          <v-btn class="cart-btn" @click="openCart">עגלה</v-btn>
          <v-slide-x-reverse-transition>
            <v-btn
              v-if="cartUnitsNumber > 0"
              class="checkout-btn"
              @click="goToCheckout"
              >{{
                isUserGuest
                  ? $t("CartSummary.guestFinishOrder")
                  : $t("CartSummary.finishOrder")
              }}</v-btn
            >
          </v-slide-x-reverse-transition>
        </div>
      </div>
      <QuotationModal
        @closeModel="closeQuotationModal"
        v-if="isQuotationModalOpen"
      />
    </div>
    <CartBtn v-else @click="openCart" class="cart-btn-moblie" :counter="getCartOrderLinesNumber" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import QuotationModal from "./Cart/QuotationModal.vue";
import CartBtn from "../helpers/Header/CartBtn.vue";
export default {
  components: { QuotationModal, CartBtn },
  name: "InfoCard",
  props: {
    isCartOpen: {
      type: Boolean,
      default: false,
    },
    cartUnitsNumber: {
      type: Number,
      default: 0,
    },
    cartPackagesNumber: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isOpen: true,
      isQuotationModalOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      getTotalCartPackges: "Orders/getTotalCartPackges",
      getCartOrderLinesNumber: "Orders/getCartOrderLinesNumber",
      isUserGuest: "AuthModule/isUserGuest",
      isMobile: "isMobile",
    }),
  },
  methods: {
    openCart() {
      this.isOpen = !this.isOpen;
      this.$emit("openCart");
    },
    closeQuotationModal() {
      this.isQuotationModalOpen = false;
    },
    goToCheckout() {
      // Add your checkout navigation logic here
      if (this.isUserGuest) {
        this.isQuotationModalOpen = true;
        return;
      }
      this.$router.push("checkout");
    },
  },
  watch: {
    isCartOpen: {
      immediate: true,
      handler(val) {
        this.isOpen = val;
      },
    },
  },
};
</script>

<style scoped lang="scss">
.info-card {
  border: 2px solid $primaryColor;
  height: 100px;
  border-radius: 20px;
  position: fixed;
  bottom: 50px;
  left: 20px;
  background: white;
  box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.25);
  z-index: 1000;
  min-width: 200px;
}

.card-content {
  gap: 20px;
  align-items: center;
  display: flex;
  height: 100%;
  border-radius: 20px;
}

.icon-bg {
  height: 100%;
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $primaryColor;
  padding: 10px;
  border-radius: 0px 15px 15px 0px;
}
.fields-wrapper {
  display: flex;
  gap: 20px;
  align-items: end;
}
.fields {
  display: flex;
  gap: 20px;
}

.field {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;
  gap: 5px;
}

.field label {
  font-weight: 400;
  display: block;
  margin-bottom: 4px;
}

.button-wrapper {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-left: 20px;
}
.cart-btn {
  border: 1px solid $primaryColor;
  box-shadow: unset;
  color: $primaryColor;
  border-radius: 50px;
}
.checkout-btn {
  background: $primaryColor;
  color: white;
  border-radius: 50px;
}
.isMobile {
  .cart-btn-moblie{
    width: 50px !important;
    height: 50px !important;
    .v-badge{
      padding: 2px 4px;
    }
  }

.fields {
    gap: 10px;
  }
  .field {
    flex-direction: row;
  }
  .info-card {
    background: rgba(255, 255, 255, 0);
    border: unset;
    box-shadow: unset;
    width: 50px;
    height: 50px;
    left: 15px;
    min-width: unset;
  }
  .icon-bg {
    width: 50px;
    border-radius: 50%;
  }
  .card-content {
    gap: 10px;
  }
  .button-wrapper {
    // flex-direction: column;
    button {
      width: fit-content;
    }
  }
}
</style>
